import React from "react";
import { Layer } from "thorium-ui";

const vars = {
   hidden: {
      opacity: 0,
      scale: 0
   },
   visible: {
      opacity: 1,
      scale: 1,

      transition: { duration: 0.1, type: "spring", stiffness: 250, damping: 20 }
   }
};

export const SuccessMessage = () => (
   <Layer
      justify="center"
      vertical
      style={{ paddingTop: "5rem", textAlign: "center" }}
      withMotion
      initial="hidden"
      animate="visible"
      variants={vars}
   >
      <h1>Success!</h1>
      <p>I will respond to your message as soon as possible!</p>
   </Layer>
);

export default SuccessMessage;
